import 'css-chunk:src/components/loader/loader-component.module.scss';export default {
  "loader-component": "loader-component_loader-component__d2gwm"
};